import t from "./types";
import { AuthAPI, BufferAuthAPI } from "../../../Auth/requestHandler";
import apiType from "../APIResponseActions/type";
import { convertDateTimeToUtc } from "../../Components/helper";
import moment from "moment";
import Config from "../../../Auth/config";

export const getDispenserList = (pageObj) => async (dispatch) => {
  try {
    const body = {
      selectedOption: pageObj.selectedOption,
      PropertyId: pageObj.PropertyId,
      lot_id: pageObj.lot_id,
      unit_id: pageObj.unit_id,
      //  year: pageObj.year,
      selectedRadio: pageObj.selectedRadio,
      timezone: pageObj.timezone,
      exportValue: pageObj.exportData ? pageObj.exportData : false,
    };

    if (pageObj.childcheckbox) {
      body.childcheckbox = pageObj.childcheckbox;
    }

    if (pageObj.currentDate) {
      const formatStartDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const startDateWithTime = `${formatStartDate} 00:00:00`;
      const formatEndDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const endDateWithTime = `${formatEndDate} 23:59:59`;

      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startDateWithTime,
        endDateWithTime
      );
      body.currentDateStartTime = startcurrent_time;
      body.currentDateEndTime = endcurrent_time;
    }

    if (pageObj.startDate && pageObj.endDate) {
      const timeFormat = moment(pageObj.startDate).format("YYYY-MM-DD");
      const startTimeFormat = `${timeFormat} 00:00:00`;

      const timeEndFormat = moment(pageObj.endDate).format("YYYY-MM-DD");
      const EndTimeFormat = `${timeEndFormat} 23:59:59`;

      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startTimeFormat,
        EndTimeFormat
      );
      body.startDate = startcurrent_time;
      body.endDate = endcurrent_time;
    }
    const url = "ticket/dispenser_report";
    if (body.exportValue) {
      try {
        return await BufferAuthAPI("domain", url, "POST", body);
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const response = await AuthAPI("domain", url, "POST", body);
      if (response && response.success) {
        await dispatch({
          type: t.FETCH_TICKET_DISPENSER_LIST,
          payload: response,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response.message,
        });
      }
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getValidationList = (pageObj) => async (dispatch) => {
  try {
    const body = {
      selectedOption: pageObj.selectedOption,
      PropertyId: pageObj.PropertyId,
      lot_id: pageObj.lot_id,
      unit_id: pageObj.unit_id,
      selectedRadio: pageObj.selectedRadio,
      timezone: pageObj.timezone,
      exportValue: pageObj.exportData ? pageObj.exportData : false,
    };

    if (pageObj.childcheckbox) {
      body.childcheckbox = pageObj.childcheckbox;
    }

    if (pageObj.currentDate) {
      const formatStartDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const startDateWithTime = `${formatStartDate} 00:00:00`;
      const formatEndDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const endDateWithTime = `${formatEndDate} 23:59:59`;

      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startDateWithTime,
        endDateWithTime
      );
      body.currentDateStartTime = startcurrent_time;
      body.currentDateEndTime = endcurrent_time;
    }

    if (pageObj.startDate && pageObj.endDate) {
      const timeFormat = moment(pageObj.startDate).format("YYYY-MM-DD");
      const startTimeFormat = `${timeFormat} 00:00:00`;

      const timeEndFormat = moment(pageObj.endDate).format("YYYY-MM-DD");
      const EndTimeFormat = `${timeEndFormat} 23:59:59`;

      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startTimeFormat,
        EndTimeFormat
      );
      body.startDate = startcurrent_time;
      body.endDate = endcurrent_time;
    }
    const url = "report/validation/list";
    if (body.exportValue) {
      try {
        return await BufferAuthAPI("domain", url, "POST", body);
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const response = await AuthAPI("domain", url, "POST", body);
      if (response && response.success) {
        await dispatch({
          type: t.FETCH_VALIDATION_LIST,
          payload: response,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response.message,
        });
      }
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getPaymentInfoData = (row) => async (dispatch) => {
  try {
    console.log("check this::::::::::::::::::", row);
    const url =
      "public/payment-receipt/" +
      row.ticketNo +
      "/" +
      row.lang +
      "/" +
      row.isMobile;
    const data = await new Promise((resolve) => {
      fetch(`${Config.baseURL}/${url}`)
        .then((blobData) => blobData.blob())
        .then((response) => {
          console.log("==== response", response);
          resolve(URL.createObjectURL(response));
        });
    });
    await dispatch({
      type: t.FETCH_PAYMENT_DOWNLOAD_DATA,
      payload: data,
    });
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const sendPaymentMail = (sendMailData) => async (dispatch) => {
  try {
    const url = "report/send-payment-mail";
    const body = sendMailData;
    const response = await AuthAPI("domain", url, "POST", body);
    console.log("Mail send Response success::::::", response);
    await dispatch({
      type: apiType.API_RESPONSE_SUCCESS,
      payload: response.message,
    });
  } catch (error) {
    console.log(error);
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.message,
    });
  }
};
